import { Controller } from "@hotwired/stimulus"
import { revealActiveItem } from "../lib/scroll_strip.mjs"

export default class extends Controller {
  static targets = ["active"]

  connect() {
    if (!this.hasActiveTarget) return

    this.frame = requestAnimationFrame(() => {
      revealActiveItem(this.element, this.activeTarget)
    })
  }

  disconnect() {
    if (this.frame) cancelAnimationFrame(this.frame)
  }
}
